import { IncentiveSource, LoyaltyOffer, LoyaltyOfferGroup } from 'state/loyalty/types';
import { maybeLocaleImages } from 'utils/graphql';
import { blockContentToPlainText } from 'utils/sanity';

import { AnimatedOfferItem } from '../loyalty-incentives-components/animated-offer-item';
import { parseIncentiveData } from '../loyalty-incentives-components/incentive-card/parse-incentive-data';
import { LoyaltyOfferGroupItem } from '../loyalty-incentives-components/loyalty-offer-group-item';
import { LoyaltyOffersItem } from '../loyalty-incentives-components/loyalty-offers-item';

export const renderOfferItem = ({
  item,
  handlePress,
  skipAnimation,
}: {
  item: LoyaltyOffer;
  handlePress: (offer: LoyaltyOffer) => void;
  skipAnimation: boolean;
}) => {
  const incentiveData = parseIncentiveData(item);
  const isPromoCode = (incentiveData.metadata || []).some(
    data => data?.value === IncentiveSource.PROMOTION_CODE
  );
  const _renderOfferItem = () => (
    <LoyaltyOffersItem handlePress={() => handlePress(item)} incentiveData={incentiveData} />
  );
  // Animate only if skipAnimation is disabled and offer source is Promo Code campaing
  return !skipAnimation && isPromoCode ? (
    <AnimatedOfferItem setSkipAnimation={(skip: boolean) => (skipAnimation = skip)}>
      {_renderOfferItem()}
    </AnimatedOfferItem>
  ) : (
    _renderOfferItem()
  );
};

const renderOfferGroupItem = ({
  item,
  handlePress,
}: {
  item: LoyaltyOfferGroup;
  handlePress: (group: LoyaltyOfferGroup) => void;
}) => {
  if (!item.groupId) {
    return null;
  }

  const image = maybeLocaleImages(item?.localizedImage);
  const name = blockContentToPlainText(item?.name?.localeRaw);
  const description = blockContentToPlainText(item?.description?.localeRaw);

  return (
    <LoyaltyOfferGroupItem
      groupId={item.groupId}
      name={name}
      description={description}
      image={image}
      imageDescription={description}
      handlePress={() => handlePress(item)}
    />
  );
};

export const LoyaltyListItem = ({
  item,
  handleOfferPress,
  handleGroupPress,
  skipAnimation,
}: {
  item: LoyaltyOffer | LoyaltyOfferGroup;
  handleOfferPress: (offer: LoyaltyOffer) => void;
  handleGroupPress: (group: LoyaltyOfferGroup) => void;
  skipAnimation: boolean;
}) => {
  if ('loyaltyEngineId' in item) {
    return renderOfferItem({ item, handlePress: handleOfferPress, skipAnimation });
  } else if ('groupId' in item) {
    return renderOfferGroupItem({ item, handlePress: handleGroupPress });
  }
  return null;
};
